// Importar o jQuery e atribuí-lo ao window
import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import _ from 'lodash';

// import Backbone from 'backbone';
import * as joint from 'jointjs';
window.joint = joint;
window.V = joint.V;
import 'jointjs/dist/joint.css';

// Expor imediatamente no escopo global antes de qualquer uso
globalThis.jQuery = globalThis.$ = $;
window.jQuery = window.$ = $; // redundante, mas garante compatibilidade

// Forçar a inicialização do bootstrap-tagsinput
import bootstrapTagsinput from 'bootstrap-tagsinput';
if (window.jQuery && !window.jQuery.fn.tagsinput) {
  bootstrapTagsinput(window.jQuery);
}

// Importar bibliotecas que dependem do jQuery
import 'bootstrap/dist/js/bootstrap.min.js';

// Importar outras bibliotecas que não dependem do jQuery
import 'node-waves';
import 'chart.js';

// Importar estilos
import 'font-awesome/css/font-awesome.min.css';
import 'toastr/build/toastr.min.css';
import 'ui-select/dist/select.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.css';

// Importar o AngularJS e módulos da aplicação
// eslint-disable-next-line no-unused-vars
import angular from 'angular';
import 'ng-tags-input';

// Importar arquivos da aplicação
import './bootstrap';
import './styles';
import './extensions';
import './modules';
